import { useEffect } from 'react';
import Box from '@mui/material/Box';

export const Outgrow = ({ calculatorUrl }: OutgrowProps) => {
  useEffect(() => {
    const outgrowScript = document.createElement('script');
    outgrowScript.src = '//dyv6f9ner1ir9.cloudfront.net/assets/js/nloader.js';
    outgrowScript.type = 'text/javascript';
    outgrowScript.async = true;

    outgrowScript.addEventListener('load', () => {
      const initScript = document.createElement('script');
      initScript.innerHTML = "initIframe('outgrowCalculator');";
      document.body.appendChild(initScript);
    });

    document.body.appendChild(outgrowScript);
  }, []);

  return (
    <Box
      id='outgrowCalculator'
      data-title='Funding Calculator'
      data-url={calculatorUrl}
      data-width='100%'
      sx={{ maxHeight: 'fit-content' }}
    />
  );
};

interface OutgrowProps {
  calculatorUrl: string;
}

Outgrow.displayName = 'Outgrow';
export default Outgrow;
